import React, { Fragment } from "react";
import { CloseOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Select, Spin } from "antd";
import { GENERIC_SPICE, GENERIC_TOUCHSTONE, PCB_SPICE, PCB_TOUCHSTONE, SPICE, TOUCHSTONE } from "../../../../constants/libraryConstants";
import TreeSelect from "../../../../components/TreeSelect";
import sierraLibrary from "../../../../services/Sierra/library/libraryStorage";
import '../../../../publicCss/netlist.css';
import { SCHEMATIC } from "../../../../services/Sierra/prelayout/prelayoutConstants";

const modelTypes = [{ key: SPICE, title: 'SPICE', type: PCB_SPICE }],
  touchstoneModel = { key: TOUCHSTONE, title: 'Touchstone', type: PCB_TOUCHSTONE };

const ModelSelect = (props) => {
  const { width, selectModelType, model, fixed, portsObj, prelayout, spice, genericSpice, touchstone, genericTouchstone, initLibraryStatus } = props;
  const { modelType, libraries } = model;

  let _modelTypes = [...modelTypes];
  if (prelayout === SCHEMATIC) {
    _modelTypes.push(touchstoneModel);
  }
  const libraryType = _modelTypes.find(m => m.key === modelType) || {};
  const libraryFiles = modelType === TOUCHSTONE ? [
    { type: "folder", name: "PCB Model", isTitle: true, children: [...(touchstone || [])] },
    { type: "folder", name: "Generic Model", isTitle: true, children: [...(genericTouchstone || [])] }]
    : [
      { type: "folder", name: "PCB Model", isTitle: true, children: [...spice] },
      { type: "folder", name: "Generic Model", isTitle: true, children: [...genericSpice] }]

  return <Fragment>
    <div className='pcb-model-select'>
      <span style={{ width, minWidth: width }}>Model Type</span>
      <Select
        value={modelType}
        onSelect={selectModelType}
        className='pcb-model-selection'
        classNames={{ popup: { root: 'pcb-model-select-dropdown' } }}
        popupMatchSelectWidth={true}
        getPopupContainer={() => document.getElementById('root')}
        disabled={fixed}
        options={_modelTypes.map(m => ({
          value: m.key,
          label: m.title
        }))}
      />
    </div>
    {<Spin spinning={initLibraryStatus ? true : false} tip={"Loading library..."}>
      {libraries.length ? libraries.map((library, index) => FileSelect({ ...props, libraryType: libraryType.type, libraryId: library.libraryId, subckt: library.subckt, libraryFiles, showTitle: index === 0 ? true : false, index, portsObj }))
        : FileSelect({ ...props, libraryType: libraryType.type, libraryId: "", libraryFiles, index: 0, portsObj })}
    </Spin>}
  </Fragment>
}

const AddEmptyModel = (addNewFileSelect) => {
  return (
    <PlusCircleOutlined
      title={'Add new model'}
      className='spice-model-add-file-icon'
      onClick={(e) => addNewFileSelect(e)} />
  );
}

const DeleteModel = (deleteModel, index) => {
  return (
    <CloseOutlined
      title={'Delete model'}
      className='spice-model-add-file-icon sierra-pre-layout-model-delete-icon'
      onClick={(e) => deleteModel(e, index)} />
  );
}

const FileSelect = (props) => {
  const { width, libraryType, libraryId, libraryFiles, showTitle = true, onSelectLibrary, selectSubckt, index, addNewFileSelect, deleteModel, fixed, portsObj, subckt } = props;
  const _libraryType = libraryType === PCB_TOUCHSTONE ? GENERIC_TOUCHSTONE : GENERIC_SPICE;
  const libraryFile = sierraLibrary.checkFile(libraryType, libraryId) || sierraLibrary.checkFile(_libraryType, libraryId);
  /*   if (!libraryFile && libraryId) {
      onSelectLibrary("", index);
    } */
  const isSpice = (libraryType || "").match(/spice/ig);
  let value = libraryFile ? libraryFile.name : '';
  const subcktList = isSpice && portsObj[libraryId] ? portsObj[libraryId].map(item => item.name) : [];
  return <Fragment key={index}>
    <div className='pcb-model-select'>
      <span style={{ width, minWidth: width }}>{showTitle ? `Model` : ''}{showTitle && !fixed ? AddEmptyModel(addNewFileSelect) : ''}</span>
      <TreeSelect
        value={value || undefined}
        onSelectItem={(file) => onSelectLibrary(file, index)}
        size='small'
        showSearch
        popupClassName='pcb-model-select-dropdown'
        className={!isSpice ? 'sierra-pre-layout-pcb-model-select sierra-pre-layout-pcb-model-touchstone-select' : "sierra-pre-layout-pcb-model-select"}
        allowClear={false}
        fileList={libraryFiles}
        getPopupContainer={() => document.getElementById('root')}
        selected={libraryId}
        disabled={fixed}
      />
      {isSpice ? <Select
        value={subckt}
        onSelect={(subckt) => selectSubckt(subckt, index)}
        className='sierra-pre-layout-pcb-model-select sierra-pre-layout-pcb-model-select-right'
        popupClassName='pcb-model-select-dropdown'
        popupMatchSelectWidth={true}
        getPopupContainer={() => document.getElementById('root')}
        disabled={fixed}
        options={subcktList.map(m => ({
          value: m,
          label: m
        }))}
      /> : null}
      {!fixed && DeleteModel(deleteModel, index)}
    </div>
  </Fragment>
}

export default ModelSelect